import { render } from "./MainSidebar.vue?vue&type=template&id=271d2fdd&ts=true"
import script from "./MainSidebar.vue?vue&type=script&lang=ts"
export * from "./MainSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__